<template>
  <div>
    <div class="container container-fluid">
      <div class="c-listing-header">
        <div class="c-listing-header__cta-container">
          <h2 class="c-listing-header__heading">Session Timeout Modal</h2>
          <span class="h-flex"></span>
        </div>
      </div>

      

      <ul>
        <li>Notify user of session timeout before actual session timeout with a modal</li>
        <li>Buttons continue cancel</li>
        <li>Extend session by pinging the server</li>
      </ul>

      <!-- Modal -->
      <!-- Button -->

      <br />
      <br />

      <div class="d-flex">
        <button v-b-modal.ahaTimeoutModal class="btn btn-lg btn-danger btn-round">
          Trigger
          Session Timeout Modal
        </button>
        <div>&nbsp;</div>
      </div>

      <br />
      <br />

      <h3>Session expires in {{value}}</h3>

      <!-- component -->
      <aha-session-timeout-modal
        ref="session-modal"
        name="session-modal"
        endpoint = "http://www.mocky.io/v2/5d3a10e22f00005b006ebfa1"
        redirect = "http://localhost:3000/#/"
        :session-time=0.25
        :translations="{
                'btnyeslabel': 'Continue',
                'btnnolabel': 'No',
                'heading': 'Session Timed Out', 
                'subheading': 'Your session is about to time out. Do you wish to continue?',
            }"
      ></aha-session-timeout-modal>
      <!-- end component -->

      <pre>
        <!-- component -->
      &lt;aha-session-timeout-modal
        @update = "timerUpdate" // udpate is for local testing, updating the timer visually
        ref="session-modal"
        name="session-modal"
        endpoint = "some url to ping to"
        redirect = "redirect url when user click on No"
        :sessionTime = 18 //in minutes
        :translations="{
                'btnyeslabel': 'Yes',
                'btnnolabel': 'No',
                'heading': 'Session Timed Out', 
                'subheading': 'Your session is about to time out. Do you wish to continue?',
            }"
      &gt;&lt;/aha-session-timeout-modal&gt;
      <!-- end component -->
      </pre>


    </div>
    <!-- End contaier -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeSet: 1,
      value: "00:00"
    };
  },
  created() {

  },
 

  mounted() {
    //this.showModal();
    // this.$nextTick(function() {
    // });
    // let minutes = 60 * this.timeSet;
    // const display = document.querySelector('#time');
    // this.startTimer(minutes, display);
  },
  methods: {

    showModal: function() {
      //this.$refs["zipcode-modal"].showModal();
    }
    /*,startTimer: function(duration, display) {
    let timer = duration, minutes, seconds;
      var countdown = setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        display.textContent = minutes + ":" + seconds;

        if (--timer < 0) {
            timer = duration;
            //clearInterval(countdown);
        }
      }, 1000);
    }*/
   ,timerUpdate: function(newValue){
     this.value = newValue;
   } 
  }
};
</script>



// WEBPACK FOOTER //
// demo/pages/components/session-timeout.vue